<template>
  <div class="testimonial-bg py-4 my-4">
     <div class="container">
      <div class="row">
        <div class="col-12">
         
            <h2 class="hk-headline text-center">
            Here’s What Our Clients Have To Say About Us.
          </h2>
        </div>
      </div>
      </div>
    <div class="container hk-container-padding mt-5">
      <div class="row g-5">
        <div class="col-12">
          <div id="client-carousel" class="carousel testimonial-cont p-4" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item"  v-for="(allclients, index) in AllClients" :key="allclients" :class="{ active: index == 0 }">
            <div class="row">
               <div class="col-12 col-md-7 col-lg-7 position-relative my-auto">
                <div class="mt-5">
                  <!-- <img src="@/assets/clients/uppercomma.svg" alt="upper">  -->
                  <p class="client-descrp">
                    {{ $t(allclients.description) }}
                  </p>
                </div>
                <div class="pt-0 pt-md-4 pt-lg-4">
                    <!-- <h2 class="clinte-name">{{ $t(allclients.name) }}</h2> -->
                    <p class="mb-0 clinte-profile">{{ $t(allclients.profile)}}</p>
                  </div>
              </div>
              <div class="col-12 col-md-5 col-lg-5 position-relative my-auto">
                <div class="mt-5">
                  <img :src="require(`@/assets/clients/${allclients.img_url}`)" :alt='$t(allclients.name)' loading="eager"  class="w-100" />
                </div>
              </div>
             
            </div>
          </div>
        </div>

        <div class="see-all">
    <div>
      <h2 class="see-all-text mb-0"><router-link :to="'/testimonials'"> {{$t('home_page.see_all')}} <span> 
        <img src="@/assets/common/right-angel-arrow.svg" alt="angel arrow"  width="100" height="100"> </span> </router-link> </h2>
    </div>
    <div class="arrow-position">
          <div>
            <button class="carousel-control-prev" type="button"
          data-bs-target="#client-carousel"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span
          ><span class="visually-hidden">Previous</span></button
        >
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#client-carousel"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span
          ><span class="visually-hidden">Next</span>
        </button>
</div>
            
    </div>
        
        </div>

        
        
      </div>
        </div>
       
      </div>
     
    </div>
  </div>
</template>

<script>
import ClientDetails from '@/assets/json/clients-details.json'

export default {
  name: "ClientTestimonialsCarousel",
  data() {
    return {
      AllClients:[]
    };
  },
  mounted(){
this.AllClients = ClientDetails.all_clients
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.testimonial-bg {
background: #F7F7F7;
 
}
.testimonial-cont{
  background: $white;
  border-radius: 10px;
}
.hk-text-p {
  line-height: 1.8;
  letter-spacing: 0.09px;
  font-size: 18px;
  padding-bottom: 2rem;
  color: $p-color;
}
.client-img {
  width: 102px;
  height: 102px;
  margin-right: 15px;
}
.testimonial-carousel-box img{
  width: calc(100% - 100px) !important;
}
.testimonial-overflow {
  overflow: auto;
  height: calc(400px - 100px);
}
small {
  font-size: 1.5rem;
}
blockquote img{
  display: inline;
  width: 45px;
}

// .testimonial-carousel-box img{
//   padding:30px;
// }
.arrow-position{
    position: absolute;
    right: 0;
    // bottom: 30px;
    z-index: 1;
    width: 100px;
    height: 50px;
    border: 1px solid #000;
    background: $white;
}
.see-all{
      position: relative;
    top: 1rem;
    display: flex;
    align-items: center;
    padding-bottom: 0rem;
    padding-top: 0rem;
    img{
    width: 12px;
    margin-left: 1rem;
    margin-top: -5px;
    }
}
.see-all-text{
  font-size: 1.25rem;
  font-weight: 700;
}
.carousel-control-next, .carousel-control-prev{
  width: 50px;
}
.arrow-position .carousel-control-prev{
border-right:1px solid #000 ;
}
.client-descrp {
    color: #202020;
font-family: Poppins;
font-size: 20px;
font-style: normal;
font-weight: 500;
}
.carousel-control-prev-icon {
    background-image: url(@/assets/common/left-angel-arrow.svg);

}
.carousel-control-next-icon {
    background-image: url(@/assets/common/right-angel-arrow.svg);
}

.carousel-control-next, .carousel-control-prev{
  opacity: unset;
}
.carousel-control-next-icon, .carousel-control-prev-icon{
  width: 1rem;
  height: 1rem;
}
//.col-md-7.col-lg-7.position-relative{
  // blockquote{
  //   position: absolute;
  //   top: 0;
  // }
  // div{
  //   position: absolute;
  //   bottom: 0;
  // }
//}
@media (max-width: 575.98px) {
  .testimonial-carousel-box img{
  width: 100%!important;
}
blockquote {
  img {
    display: inline;
    width: 28px;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}
.client-descrp{
  padding-top: 0px;
  font-size: 1rem;
  line-height: 28px;
}
}

.testimonial-bg{
  padding-left: 5px;
  padding-right: 5px;
  .hk-heading-text{
    font-size: 1.5rem;
    letter-spacing: -0.48px;
    line-height: 32px;
    font-weight: 800;
    text-align: center;
}
.carousel-item{
  p{
    text-align: center;
line-height: 24px;
letter-spacing: -0.32px;
margin-bottom: 0px;
  }
}
blockquote{
  text-align: center;
}
}
.clinte-name{
  font-size: 1rem;
    line-height: 31px;
    font-weight: 800;
    margin-bottom: 0;
    text-align: center;
}
.clinte-profile{
  font-size: 14px;
}
.see-all-text{
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.28px;
    line-height: 22px;
}
.see-all img{
  width: 6px;
    margin-left: 0.4rem;
    margin-top: -5px;
}
}
</style>
